import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useGlobalSettings } from '../../hooks/useGlobalSettings';
import { useAvatar } from '../../hooks/useAvatar';
import { useStartpageData } from '../../hooks/pages/useStartpageData';
import QuizButton from '../common/QuizButton';
import Animation from '../common/Animation';

export default function QuizStartingPage({ station, theme }) {
  const navigate = useNavigate();
  const { data: pageData, error: pageDataError } = useStartpageData(station);
  const { globalSettings, error: globalSettingsError } = useGlobalSettings();
  const { avatarData, error: avatarDataError } = useAvatar('Startseite');

  if (globalSettingsError || pageDataError || avatarDataError) {
    return <div>Fehler: {globalSettingsError || pageDataError || avatarDataError}</div>;
  }
  if (!globalSettings || !pageData || !avatarData) {
    return <div>Laden…</div>;
  }

  const { question } = pageData;
  const { logoUrl } = globalSettings;
  const avatar = avatarData[0]?.animation;

  const buttons = [
    { text: 'Leicht', route: '/quiz/quizLeicht' },
    { text: 'Schwer', route: '/quiz/quizSchwer' },
  ];

  return (
    <div
      className="min-h-screen pointer-events-auto"
      style={{ backgroundColor: theme.backgroundColor, color: theme.textColor }}
    >
      <div className="flex h-screen">
        <div className="flex-1 md:w-1/3 relative pointer-events-auto">
          <img
            src={logoUrl}
            alt="Logo"
            className="absolute top-16 left-16 h-16 pointer-events-auto z-10"
          />
          <div className="absolute bottom-0 transform -translate-x-80">
            <Animation
              src={avatar}
              className="object-contain portrait:h-full portrait:w-auto landscape:min-w-fit"
            />
          </div>
        </div>
        <div
          className="flex flex-2 flex-col justify-center md:w-1/2 rounded-br-[150px] rounded-tl-[150px] px-12 py-20 mr-48 ml-8 my-28 pointer-events-auto z-10"
          style={{ backgroundColor: theme.foregroundColor }}
        >
          <ReactMarkdown className="text-5xl uppercase pointer-events-auto">
            {question}
          </ReactMarkdown>
          <div className="grid grid-cols-2 gap-10 mt-16 pointer-events-auto">
            {buttons.map(({ text, route }) => (
              <QuizButton
                key={route}
                text={text}
                theme={theme}
                handleClick={() => navigate(route)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}